import { newE2EPage } from "@stencil/core/testing";

describe("uic-radio", () => {
    it("should render", async () => {
        const page = await newE2EPage({
            html: `<uic-radio label="Label" icon="uic:test"></uic-radio>`,
        });

        const component = await page.find("uic-radio");
        expect(component).toMatchSnapshot();
    });

    it("should emit uicChange when clicked", async () => {
        const page = await newE2EPage({
            html: `<uic-radio label="Label"></uic-radio>`,
        });

        const component = await page.find("uic-radio");
        const uicChange = await page.spyOnEvent("uicChange");

        expect(await component.getProperty("checked")).toBe(false);

        await component.click();

        expect(await component.getProperty("checked")).toBe(true);
        expect(uicChange).toHaveReceivedEventTimes(1);
    });

    it("should have tabindex 0", async () => {
        const page = await newE2EPage({
            html: `<uic-radio label="Label"></uic-radio>`,
        });

        const component = await page.find("uic-radio");
        expect(component.getAttribute("tabindex")).toBe("0");
    });

    it("should have no tabindex when disabled", async () => {
        const page = await newE2EPage({
            html: `<uic-radio disabled label="Label"></uic-radio>`,
        });

        const component = await page.find("uic-radio");
        expect(component.getAttribute("tabindex")).toBe("-1");
    });
});
